import React, { Component } from "react";
import { MDBDataTable } from "mdbreact";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Container,
  Badge,
  Input,
  FormGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import {
  getTransportRequests,
  acceptTransportRequest,
  rejectTransportRequest,
  cancelTransportRequest,
} from "../../Endpoint/Admin/index";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import classnames from "classnames";
import ConfirmModal from "../../components/Common/ConfirmModal";

class TransportRequestList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isLoaded: false,
      statusFilter: "",
      activeTab: "all",
      breadcrumbItems: [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Transport Requests", link: "#" },
      ],
      tableData: {
        columns: [
          { label: "Request #", field: "requestNumber", sort: "asc", width: 120 },
          { label: "Guest", field: "guest", sort: "asc", width: 150 },
          { label: "Services", field: "services", sort: "asc", width: 150 },
          { label: "Date/Time", field: "dateTime", sort: "asc", width: 150 },
          { label: "Passengers", field: "passengers", sort: "asc", width: 80 },
          { label: "Price", field: "price", sort: "asc", width: 100 },
          { label: "Status", field: "status", sort: "asc", width: 100 },
          { label: "Actions", field: "actions", sort: "disabled", width: 150 },
        ],
        rows: [],
      },
      // Modal states
      showAcceptModal: false,
      showReasonModal: false,
      reasonModalType: "", // "reject" or "cancel"
      selectedRequestId: null,
      reasonText: "",
      actionLoading: false,
    };
  }

  componentDidMount() {
    this.getAllRequests();
  }

  getAllRequests = () => {
    const { statusFilter } = this.state;
    const params = {};
    if (statusFilter) params.status = statusFilter;

    getTransportRequests(params)
      .then((result) => {
        if (result && result.status === 200) {
          // API returns { data: { requests: [...], pagination: {...} } }
          const requests = result.data?.requests || result.data || [];
          const rows = requests.map((request) => this.formatRequestRow(request));
          this.setState({
            isLoaded: true,
            items: requests,
            tableData: { ...this.state.tableData, rows },
          });
        } else {
          toast.error(result?.message || "Failed to fetch requests");
        }
      })
      .catch((err) => {
        console.error("Error fetching transport requests:", err);
        toast.error("Error fetching transport requests");
      });
  };

  formatRequestRow = (request) => {
    const formatDate = (date) => {
      if (!date) return "N/A";
      return new Date(date).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    };

    // Get service category info
    const categoryLabels = {
      protocol: "Protocol",
      transport: "Transport",
      protocol_transport: "Protocol & Transport",
      day_rental: "Day Rental",
      outstation: "Outstation",
      // Legacy
      airport: "Airport",
      intercity: "Inter-city",
    };

    const categoryColors = {
      protocol: "info",
      transport: "primary",
      protocol_transport: "success",
      day_rental: "warning",
      outstation: "danger",
      airport: "secondary",
      intercity: "secondary",
    };

    const serviceTypeLabels = {
      arrival: "Arrival",
      departure: "Departure",
      both: "Arrival & Departure",
    };

    const tierLabels = {
      standard: "Standard",
      comfort: "Comfort",
      vip: "VIP",
    };

    const tierColors = {
      standard: "light",
      comfort: "info",
      vip: "warning",
    };

    // Build services display based on new structure
    const serviceCategory = request.serviceCategory || "airport";
    const serviceType = request.serviceType;
    const tierType = request.tierType;

    // Get the first relevant date based on service type
    let displayDate, displayTime;
    if (serviceCategory === "day_rental") {
      displayDate = request.dayRentalDetails?.date || request.pickupDetails?.date;
      displayTime = request.dayRentalDetails?.startTime || request.pickupDetails?.time;
    } else if (serviceCategory === "outstation") {
      displayDate = request.outstationDetails?.departureDate || request.pickupDetails?.date;
      displayTime = request.outstationDetails?.departureTime || request.pickupDetails?.time;
    } else {
      const pickupDate = request.pickupDetails?.date;
      const dropDate = request.dropDetails?.date;
      displayDate = pickupDate || dropDate;
      displayTime = request.pickupDetails?.time || request.dropDetails?.time;
    }

    // Status color mapping
    const statusColors = {
      pending: "warning",
      accepted: "info",
      rejected: "danger",
      driver_assigned: "primary",
      in_progress: "info",
      completed: "success",
      cancelled: "secondary",
    };

    const statusLabels = {
      pending: "Pending",
      accepted: "Accepted",
      rejected: "Rejected",
      driver_assigned: "Driver Assigned",
      in_progress: "In Progress",
      completed: "Completed",
      cancelled: "Cancelled",
    };

    return {
      requestNumber: (
        <Link to={`/transport/request/${request._id}`} className="font-weight-bold text-primary">
          {request.requestNumber}
        </Link>
      ),
      guest: (
        <div>
          <span className="font-weight-medium">{request.contactName || request.userId?.name || "N/A"}</span>
          {request.contactMobile && (
            <small className="d-block text-muted">{request.contactMobile}</small>
          )}
        </div>
      ),
      services: (
        <div>
          {/* Service Category */}
          <Badge color={categoryColors[serviceCategory] || "secondary"} className="mr-1 mb-1" style={{ fontSize: "11px" }}>
            {categoryLabels[serviceCategory] || serviceCategory}
          </Badge>
          {/* Service Type (Arrival/Departure) */}
          {serviceType && (
            <Badge color="soft-dark" className="mr-1 mb-1" style={{ fontSize: "10px" }}>
              {serviceTypeLabels[serviceType] || serviceType}
            </Badge>
          )}
          {/* Tier Type */}
          {tierType && (
            <Badge color={tierColors[tierType] || "light"} className="mr-1 mb-1" style={{ fontSize: "10px" }}>
              {tierLabels[tierType] || tierType}
            </Badge>
          )}
          {/* Day Rental: show hours */}
          {serviceCategory === "day_rental" && request.rentalHours && (
            <Badge color="soft-warning" className="mb-1" style={{ fontSize: "10px" }}>
              {request.rentalHours}h
            </Badge>
          )}
          {/* Outstation: show trip type */}
          {serviceCategory === "outstation" && request.tripType && (
            <Badge color="soft-danger" className="mb-1" style={{ fontSize: "10px" }}>
              {request.tripType === "one_way" ? "One-way" : "Return"}
            </Badge>
          )}
          {/* Legacy services display */}
          {!request.serviceCategory && request.services && (
            <>
              {request.services.pickup && <Badge color="soft-primary" className="mr-1 mb-1" style={{ fontSize: "10px" }}>Pickup</Badge>}
              {request.services.drop && <Badge color="soft-info" className="mr-1 mb-1" style={{ fontSize: "10px" }}>Drop</Badge>}
              {request.services.meetAndGreet && <Badge color="soft-success" className="mr-1 mb-1" style={{ fontSize: "10px" }}>M&G</Badge>}
            </>
          )}
        </div>
      ),
      dateTime: (
        <div>
          <span>{formatDate(displayDate)}</span>
          {displayTime && <small className="d-block text-muted">{displayTime}</small>}
        </div>
      ),
      passengers: (
        <span>
          <i className="ri-user-line mr-1"></i>
          {request.passengers || 1}
        </span>
      ),
      price: (
        <span className={`font-weight-bold ${request.quoteStatus === 'pending_quote' ? 'text-warning' : 'text-success'}`}>
          {request.quoteStatus === 'pending_quote' ? (
            <span><i className="ri-time-line mr-1"></i>Quote Pending</span>
          ) : request.quoteStatus === 'quoted' ? (
            <span><i className="ri-price-tag-3-line mr-1"></i>${request.quotedPrice?.amount || 0}</span>
          ) : (
            `$${request.pricing?.totalPrice || 0}`
          )}
        </span>
      ),
      status: (
        <div>
          <Badge color={statusColors[request.status] || "secondary"}>
            {statusLabels[request.status] || request.status}
          </Badge>
          {/* Show quote status for day_rental/outstation */}
          {request.quoteStatus && request.quoteStatus !== 'not_applicable' && (
            <Badge
              color={request.quoteStatus === 'pending_quote' ? 'warning' :
                     request.quoteStatus === 'quoted' ? 'info' :
                     request.quoteStatus === 'accepted' ? 'success' : 'danger'}
              className="ml-1"
              style={{ fontSize: "9px" }}
            >
              {request.quoteStatus === 'pending_quote' ? 'Needs Quote' :
               request.quoteStatus === 'quoted' ? 'Awaiting Response' :
               request.quoteStatus === 'accepted' ? 'Quote OK' : 'Quote Declined'}
            </Badge>
          )}
        </div>
      ),
      actions: (
        <div className="d-flex">
          <Link to={`/transport/request/${request._id}`}>
            <Button color="info" size="sm" className="mr-1 btn-icon" title="View Details">
              <i className="ri-eye-line"></i>
            </Button>
          </Link>
          {request.status === "pending" && (
            <>
              <Button
                color="success"
                size="sm"
                className="mr-1 btn-icon"
                onClick={() => this.handleAccept(request._id)}
                title="Accept"
              >
                <i className="ri-check-line"></i>
              </Button>
              <Button
                color="danger"
                size="sm"
                className="btn-icon"
                onClick={() => this.handleReject(request._id)}
                title="Reject"
              >
                <i className="ri-close-line"></i>
              </Button>
            </>
          )}
          {["pending", "accepted", "driver_assigned"].includes(request.status) && (
            <Button
              color="warning"
              size="sm"
              className="ml-1 btn-icon"
              onClick={() => this.handleCancel(request._id)}
              title="Cancel"
            >
              <i className="ri-forbid-line"></i>
            </Button>
          )}
        </div>
      ),
    };
  };

  // Modal toggle handlers
  toggleAcceptModal = () => this.setState({ showAcceptModal: !this.state.showAcceptModal });
  toggleReasonModal = () => this.setState({ showReasonModal: !this.state.showReasonModal, reasonText: "" });

  handleAccept = (id) => {
    this.setState({ selectedRequestId: id, showAcceptModal: true });
  };

  confirmAccept = () => {
    const { selectedRequestId } = this.state;
    this.setState({ actionLoading: true });
    acceptTransportRequest(selectedRequestId)
      .then((response) => {
        if (response && response.status === 200) {
          toast.success("Request accepted successfully");
          this.getAllRequests();
        } else {
          toast.error(response?.message || "Failed to accept request");
        }
      })
      .catch(() => toast.error("Error accepting request"))
      .finally(() => {
        this.setState({ actionLoading: false, showAcceptModal: false, selectedRequestId: null });
      });
  };

  handleReject = (id) => {
    this.setState({ selectedRequestId: id, reasonModalType: "reject", showReasonModal: true });
  };

  handleCancel = (id) => {
    this.setState({ selectedRequestId: id, reasonModalType: "cancel", showReasonModal: true });
  };

  confirmReasonAction = () => {
    const { selectedRequestId, reasonModalType, reasonText } = this.state;
    if (!reasonText.trim()) {
      toast.error("Please enter a reason");
      return;
    }
    this.setState({ actionLoading: true });

    const apiCall = reasonModalType === "reject"
      ? rejectTransportRequest(selectedRequestId, reasonText)
      : cancelTransportRequest(selectedRequestId, reasonText);

    apiCall
      .then((response) => {
        if (response && response.status === 200) {
          toast.success(reasonModalType === "reject" ? "Request rejected" : "Request cancelled");
          this.getAllRequests();
        } else {
          toast.error(response?.message || `Failed to ${reasonModalType} request`);
        }
      })
      .catch(() => toast.error(`Error ${reasonModalType}ing request`))
      .finally(() => {
        this.setState({
          actionLoading: false,
          showReasonModal: false,
          selectedRequestId: null,
          reasonText: "",
          reasonModalType: "",
        });
      });
  };

  handleFilterChange = (e) => {
    this.setState({ [e.target.name]: e.target.value }, () => {
      this.getAllRequests();
    });
  };

  setActiveTab = (tab) => {
    const statusMap = {
      all: "",
      pending: "pending",
      accepted: "accepted",
      assigned: "driver_assigned",
      completed: "completed",
      cancelled: "cancelled",
    };

    this.setState(
      { activeTab: tab, statusFilter: statusMap[tab] || "" },
      () => this.getAllRequests()
    );
  };

  render() {
    const { activeTab } = this.state;

    const tabs = [
      { key: "all", label: "All", icon: "ri-list-check" },
      { key: "pending", label: "Pending", icon: "ri-time-line" },
      { key: "accepted", label: "Accepted", icon: "ri-checkbox-circle-line" },
      { key: "assigned", label: "Driver Assigned", icon: "ri-car-line" },
      { key: "completed", label: "Completed", icon: "ri-check-double-line" },
      { key: "cancelled", label: "Cancelled", icon: "ri-close-circle-line" },
    ];

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Transport Management" breadcrumbItems={this.state.breadcrumbItems} />

            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h4 className="card-title mb-0">
                        <i className="ri-car-line mr-2"></i>
                        Transport Requests
                      </h4>
                      <div>
                        <Link to="/transport/services" className="mr-2">
                          <Button color="secondary" outline>
                            <i className="ri-settings-3-line mr-1"></i> Services
                          </Button>
                        </Link>
                        <Link to="/transport/drivers">
                          <Button color="primary" outline>
                            <i className="ri-user-2-line mr-1"></i> Drivers
                          </Button>
                        </Link>
                      </div>
                    </div>

                    {/* Status Tabs */}
                    <Nav tabs className="nav-tabs-custom mb-4">
                      {tabs.map((tab) => (
                        <NavItem key={tab.key}>
                          <NavLink
                            className={classnames({ active: activeTab === tab.key })}
                            onClick={() => this.setActiveTab(tab.key)}
                            style={{ cursor: "pointer" }}
                          >
                            <i className={`${tab.icon} mr-1`}></i>
                            {tab.label}
                          </NavLink>
                        </NavItem>
                      ))}
                    </Nav>

                    <MDBDataTable
                      responsive
                      bordered
                      striped
                      hover
                      noBottomColumns
                      data={this.state.tableData}
                      entriesOptions={[10, 25, 50, 100]}
                      entries={10}
                      pagesAmount={4}
                      className="transport-table"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Accept Confirmation Modal */}
        <ConfirmModal
          isOpen={this.state.showAcceptModal}
          toggle={this.toggleAcceptModal}
          onConfirm={this.confirmAccept}
          title="Accept Transport Request"
          message="Are you sure you want to accept this transport request?"
          confirmText="Accept"
          confirmColor="success"
          icon="ri-checkbox-circle-line"
          loading={this.state.actionLoading}
        />

        {/* Reason Input Modal (for Reject/Cancel) */}
        <Modal isOpen={this.state.showReasonModal} toggle={this.toggleReasonModal} centered>
          <ModalHeader toggle={this.toggleReasonModal}>
            {this.state.reasonModalType === "reject" ? "Reject Request" : "Cancel Request"}
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Please enter a reason:</Label>
              <Input
                type="textarea"
                rows="3"
                value={this.state.reasonText}
                onChange={(e) => this.setState({ reasonText: e.target.value })}
                placeholder={this.state.reasonModalType === "reject"
                  ? "Enter rejection reason..."
                  : "Enter cancellation reason..."}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={this.toggleReasonModal} disabled={this.state.actionLoading}>
              Cancel
            </Button>
            <Button
              color={this.state.reasonModalType === "reject" ? "warning" : "danger"}
              onClick={this.confirmReasonAction}
              disabled={this.state.actionLoading}
            >
              {this.state.actionLoading ? (
                <><i className="bx bx-loader bx-spin mr-1"></i> Processing...</>
              ) : (
                this.state.reasonModalType === "reject" ? "Reject" : "Cancel Request"
              )}
            </Button>
          </ModalFooter>
        </Modal>

        <ToastContainer />
      </React.Fragment>
    );
  }
}

export default TransportRequestList;
